import { render, staticRenderFns } from "./projectnew.vue?vue&type=template&id=3bd2e6a3&scoped=true&"
import script from "./projectnew.vue?vue&type=script&lang=js&"
export * from "./projectnew.vue?vue&type=script&lang=js&"
import style0 from "./projectnew.vue?vue&type=style&index=0&id=3bd2e6a3&lang=less&scoped=true&"
import style1 from "./projectnew.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd2e6a3",
  null
  
)

export default component.exports